import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useSolutionSharePageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: solutionSharePageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
      de: deSolutionSharePageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
    }
  `);

  return data[locale];
};
